import { createFeatureSelector, createSelector } from '@ngrx/store';
import { IAuthState } from './auth-state';
import { StateSlice } from '../state-slice';
import { AuthSession } from '@core/models/auth/auth-session';

export const selectAuthState = createFeatureSelector<IAuthState>(StateSlice.AUTH);

/**
 * Returns company authentication token.
 * @param state
 */
export const getCompanyAuthentication = createSelector(
    selectAuthState,
    (state: IAuthState): AuthSession => (state ? state.company : null)
);

/**
 * Returns user authentication token.
 * @param state
 * @returns {AuthSession}
 */
export const getUserAuthentication = createSelector(
    selectAuthState,
    (state: IAuthState): AuthSession => (state ? state.user : null)
);

export const isUserAuthenticated = createSelector(
    getUserAuthentication,
    (authSession: AuthSession): boolean => {
        return !!authSession?.access_token?.length;
    }
);

export const isAuthenticated = createSelector(
    getCompanyAuthentication,
    (authSession: AuthSession): boolean => {
        return !!authSession?.access_token?.length;
    }
);
